var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1413 6.175L12.8913 1.975L14.2913 0.575C14.6746 0.191667 15.1456 0 15.7043 0C16.2623 0 16.733 0.191667 17.1163 0.575L18.5163 1.975C18.8996 2.35833 19.0996 2.821 19.1163 3.363C19.133 3.90433 18.9496 4.36667 18.5663 4.75L17.1413 6.175ZM15.6913 7.65L5.09131 18.25H0.841309V14L11.4413 3.4L15.6913 7.65Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.c4bcd630f917b354ad006463d0801d8b.svg";
export { ForwardRef as ReactComponent };